var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _path17, _path18, _path19, _text18, _text19, _g, _text20, _g2, _g3, _text21, _g4, _text22, _g5, _g6, _g7, _text23, _g8, _text24, _text25, _text26, _text27, _text28, _text29, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLasVegas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 877.94 525.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        opacity: .3;\n      }\n\n      .cls-4, .cls-5, .cls-2, .cls-6, .cls-7, .cls-3, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-5, .cls-2, .cls-3 {\n        font-family: Bull-Regular, Bull;\n        font-size: 12.8px;\n      }\n\n      .cls-4, .cls-11 {\n        opacity: .5;\n      }\n\n      .cls-5 {\n        opacity: .93;\n      }\n\n      .cls-14, .cls-13 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-15 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-16 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-17 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-18 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-6, .cls-13 {\n        font-family: Bull-Heavy1, Bull;\n        font-size: 16.5px;\n        font-weight: 800;\n      }\n\n      .cls-19 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-20 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-21 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-22 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-23 {\n        fill: #010101;\n      }\n\n      .cls-24 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-25 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-3, .cls-26 {\n        letter-spacing: 0em;\n      }\n\n      .cls-27 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-8 {\n        opacity: .7;\n      }\n\n      .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        isolation: isolate;\n      }\n\n      .cls-9 {\n        opacity: .8;\n      }\n\n      .cls-10 {\n        opacity: .9;\n      }\n\n      .cls-12 {\n        opacity: .6;\n      }\n\n      .cls-28 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-29 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-30 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-31 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-32 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-33 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-34 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-35 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-36 {\n        letter-spacing: -.07em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m771.27,96.45l-1.28,8.53,2.57,3.49,1.28-8.53,8.56,1.29-2.57-3.49-8.56-1.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m766.89,90.65l-1.29,8.52,2.58,3.49,1.29-8.53,8.55,1.29-2.57-3.49-8.56-1.29h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m762.52,84.69l-1.29,8.52,2.58,3.49,1.28-8.52,8.56,1.29-2.58-3.49-8.55-1.29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m774.06,110.5l2.58,3.49,1.28-8.52,8.56,1.29-2.58-3.49-8.55-1.29-1.29,8.53h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m778.11,115.99l2.58,3.49,1.29-8.53,8.55,1.29-2.57-3.49-8.56-1.29-1.29,8.52h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m784.23,126.36l3.44-2.62,2.63,3.42-3.47,2.63-2.6-3.43Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m786.83,129.79l3.44-2.64,2.63,3.44-3.42,2.67-2.65-3.48Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m789.48,133.27l3.44-2.62,2.62,3.44-3.36,2.59-2.69-3.4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m787.63,123.76l3.44-2.63,2.63,3.44-3.44,2.63-2.63-3.44Zm5.26,6.86l3.44-2.63,2.62,3.44-3.44,2.63-2.62-3.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m790.22,127.24l3.44-2.63,2.64,3.44-3.47,2.59-2.61-3.4Zm.8-6.09l3.44-2.63,2.62,3.44-3.44,2.63-2.62-3.44Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m793.66,124.58l3.44-2.63,2.63,3.44-3.42,2.63-2.65-3.44Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m796.3,128.02l3.42-2.63,2.63,3.44-3.44,2.63-2.61-3.43Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m794.43,118.56l3.44-2.63,2.63,3.44-3.44,2.63-2.63-3.44Zm5.26,6.85l3.44-2.63,2.63,3.44-3.44,2.62-2.63-3.43Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m797.04,121.99l3.44-2.63,2.63,3.44-3.44,2.63-2.63-3.44Zm.67-6.15l3.44-2.63,2.63,3.44-3.44,2.63-2.63-3.44Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m800.32,119.3l3.44-2.63,2.62,3.44-3.44,2.63-2.62-3.44Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m802.94,122.72l3.44-2.63,2.64,3.44-3.44,2.64-2.63-3.45Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(256.54 99.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T8"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(323.08 71.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 8.65,
    y: 0
  }, "6"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(352.49 174.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T5"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(249.73 55.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T7"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(195.39 61.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T9"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(210.7 253.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T10"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(674.75 170.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 8.4,
    y: 0
  }, "4"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(706.94 153.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T3"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(682.32 108.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T2"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(693.37 46.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T1"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(812.13 182.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T17"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(811.69 455.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T16"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(798.72 477.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T15"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(749.13 466.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T14"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(300.72 501.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T13"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(104.48 350.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T12"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(72.31 291.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 9.39,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 16.04,
    y: 0
  }, "1"))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m480.19,221.84c-1.09.07-2.17-.29-3-1-.78-.74-1.22-1.76-1.23-2.83h1.46c.03,1.46,1.23,2.63,2.7,2.6.02,0,.04,0,.06,0,.69.04,1.38-.16,1.94-.57.48-.38.75-.96.72-1.57.02-.45-.13-.89-.42-1.23-.4-.39-.89-.69-1.43-.87l-1.8-.68c-.8-.27-1.52-.74-2.08-1.37-.44-.6-.67-1.33-.64-2.08,0-.44.09-.88.27-1.29.19-.39.45-.73.78-1,.36-.29.76-.51,1.2-.65.5-.16,1.02-.23,1.54-.23,1-.05,1.98.27,2.75.91.7.65,1.11,1.55,1.13,2.5h-1.46c-.02-.59-.27-1.15-.69-1.56-.48-.4-1.1-.61-1.73-.57-.6-.03-1.2.14-1.69.5-.42.32-.67.83-.65,1.36-.02.48.14.95.44,1.32.4.42.89.74,1.44.93l1.83.7c.77.25,1.46.7,2,1.3.44.57.66,1.28.62,2,0,.49-.09.99-.28,1.44-.19.42-.47.79-.82,1.09-.38.31-.82.55-1.29.69-.55.14-1.12.19-1.68.16h0Zm6.7-12.6h7.15v1.3h-5.7v4h5.53v1.3h-5.53v4.5h5.9v1.3h-7.35v-12.4Zm15.58,12.6c-.87,0-1.74-.15-2.55-.48-.75-.32-1.42-.78-2-1.35-.57-.57-1.03-1.25-1.34-2-.65-1.63-.65-3.46,0-5.09.31-.75.76-1.43,1.34-2,.57-.57,1.25-1.03,2-1.35,1.51-.6,3.18-.65,4.72-.15.65.21,1.26.53,1.8.94,1.05.84,1.76,2.04,2,3.37h-1.55c-.12-.49-.33-.95-.61-1.37-.54-.82-1.35-1.42-2.29-1.7-.51-.15-1.03-.23-1.56-.23-.67,0-1.33.13-1.95.39-.59.24-1.13.61-1.57,1.07-.43.46-.77,1.01-1,1.6-.26.64-.39,1.31-.38,2,0,.68.13,1.36.38,2,.23.59.57,1.13,1,1.6.45.46.98.82,1.57,1.07.62.26,1.28.4,1.95.39,1.03.03,2.03-.29,2.86-.9.8-.59,1.37-1.45,1.6-2.42h1.55c-.12.68-.38,1.33-.74,1.92-.34.57-.79,1.07-1.31,1.47-.54.41-1.15.73-1.8.94-.69.2-1.4.3-2.12.28h0Zm10.95-11.3h-3.66v-1.3h8.88v1.3h-3.78v11.1h-1.44v-11.1Zm12.67,11.3c-.87,0-1.73-.16-2.54-.48-.75-.32-1.43-.78-2-1.36-.57-.58-1.03-1.25-1.35-2-.33-.8-.5-1.66-.49-2.53,0-.87.16-1.73.49-2.54.31-.75.77-1.43,1.35-2,.57-.57,1.25-1.03,2-1.35.81-.33,1.68-.49,2.55-.49.87,0,1.73.16,2.53.49.75.32,1.43.78,2,1.35.58.57,1.03,1.25,1.34,2,.33.81.5,1.67.49,2.54,0,.87-.16,1.73-.49,2.53-.31.75-.77,1.43-1.34,2-.57.58-1.25,1.04-2,1.36-.81.33-1.67.49-2.54.48h0Zm0-1.34c2.01.03,3.83-1.19,4.55-3.07.25-.64.37-1.32.37-2,0-.69-.12-1.36-.38-2-.23-.59-.57-1.13-1-1.6-.44-.46-.97-.82-1.56-1.06-1.25-.51-2.66-.51-3.91,0-.59.24-1.12.6-1.56,1.06-.43.47-.77,1.01-1,1.6-.26.64-.38,1.31-.38,2,0,.68.12,1.36.37,2,.47,1.21,1.41,2.17,2.6,2.68.6.26,1.25.39,1.9.39h0Zm9.1-11.26h3.85c1.05-.05,2.08.31,2.87,1,.7.7,1.06,1.66,1,2.65.03.84-.23,1.66-.73,2.33-.5.63-1.21,1.07-2,1.24l3.52,5.22h-1.7l-3.37-5.1h-2v5.1h-1.44v-12.44Zm3.76,6c.67.03,1.32-.19,1.83-.62.87-.99.87-2.47,0-3.46-.51-.43-1.17-.65-1.84-.61h-2.34v4.7h2.35Zm15.08-6v12.4h-1.44v-10.9l-2.36.74-.35-1.26,2.9-.95,1.25-.03Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m181.87,379.65c-1.09.06-2.16-.3-3-1-.78-.74-1.22-1.76-1.23-2.83h1.46c.02.71.32,1.39.83,1.88.52.49,1.22.75,1.93.72.69.04,1.38-.17,1.94-.58.48-.37.75-.95.72-1.56.02-.45-.13-.9-.42-1.24-.41-.39-.9-.68-1.43-.86l-1.78-.68c-.81-.27-1.53-.74-2.09-1.38-.44-.6-.67-1.33-.64-2.07,0-.45.09-.89.28-1.29.18-.39.44-.73.77-1,.36-.29.76-.5,1.2-.64.5-.16,1.02-.24,1.55-.23.99-.05,1.97.27,2.74.9.7.65,1.11,1.56,1.13,2.51h-1.46c-.02-.59-.26-1.16-.69-1.57-.48-.4-1.09-.61-1.72-.57-.61-.03-1.21.15-1.7.51-.42.32-.66.82-.64,1.35-.02.48.13.95.43,1.33.4.42.9.73,1.45.92l1.82.7c.77.25,1.46.7,2,1.3.44.57.65,1.28.61,2,0,.49-.09.98-.28,1.44-.19.42-.47.8-.82,1.1-.38.31-.82.55-1.29.69-.55.13-1.11.18-1.67.15h0Zm6.72-12.6h7.15v1.3h-5.7v4h5.53v1.3h-5.53v4.5h5.92v1.3h-7.36v-12.4Zm15.57,12.6c-.88.01-1.75-.16-2.56-.49-1.53-.63-2.74-1.84-3.37-3.37-.33-.81-.5-1.68-.49-2.56,0-.87.16-1.73.49-2.53.62-1.53,1.84-2.75,3.38-3.37.81-.33,1.68-.5,2.55-.49.74,0,1.47.11,2.17.33.65.2,1.26.52,1.8.94.52.41.97.91,1.32,1.47.36.58.61,1.23.73,1.9h-1.55c-.12-.48-.32-.94-.6-1.36-.27-.39-.61-.73-1-1-.4-.29-.84-.52-1.31-.67-.51-.16-1.03-.23-1.56-.23-.69-.01-1.37.12-2,.39-1.17.53-2.09,1.48-2.57,2.67-.51,1.29-.51,2.71,0,4,.73,1.87,2.55,3.09,4.56,3.06,1.03.03,2.03-.28,2.86-.89.8-.6,1.36-1.45,1.6-2.42h1.55c-.23,1.34-.94,2.54-2,3.39-.54.41-1.15.73-1.8.94-.71.21-1.46.31-2.2.29h0Zm10.95-11.3h-3.67v-1.3h8.88v1.3h-3.78v11.1h-1.43v-11.1Zm12.68,11.3c-.87,0-1.73-.16-2.54-.49-1.53-.64-2.75-1.86-3.39-3.39-.65-1.63-.65-3.44,0-5.07.32-.75.78-1.43,1.35-2,.57-.57,1.25-1.03,2-1.34.81-.33,1.68-.5,2.55-.49.87,0,1.73.16,2.53.49.75.31,1.43.77,2,1.34.57.57,1.03,1.25,1.35,2,.64,1.63.64,3.44,0,5.07-.32.75-.78,1.43-1.35,2-.57.58-1.25,1.04-2,1.36-.79.34-1.64.52-2.5.52h0Zm0-1.35c.67,0,1.33-.12,1.95-.38.59-.25,1.12-.61,1.57-1.07.43-.47.77-1.02,1-1.62.5-1.29.5-2.71,0-4-.23-.59-.57-1.13-1-1.6-.44-.46-.97-.82-1.56-1.06-.62-.26-1.29-.4-1.96-.4-.69,0-1.37.12-2,.38-.58.24-1.11.6-1.55,1.06-.93.96-1.44,2.26-1.41,3.6,0,.68.12,1.36.37,2,.46,1.21,1.4,2.18,2.59,2.69.63.27,1.31.4,2,.4h0Zm9.08-11.26h3.86c1.05-.05,2.07.3,2.86,1,.7.7,1.06,1.66,1,2.64.03.84-.22,1.66-.72,2.34-.51.63-1.21,1.07-2,1.24l3.52,5.22h-1.7l-3.37-5.1h-2v5.1h-1.44v-12.44Zm3.76,6c.67.04,1.33-.18,1.83-.62.46-.46.7-1.09.66-1.74.04-.64-.19-1.26-.64-1.71-.51-.44-1.18-.66-1.85-.61h-2.34v4.68h2.34Zm19.52,5.13v1.3h-8.07v-.74c0-.59.1-1.17.32-1.71.21-.48.48-.92.82-1.32.33-.38.69-.71,1.1-1l1.13-.76c.53-.33.99-.62,1.38-.87.34-.21.66-.45.94-.73.22-.22.4-.48.52-.77.12-.32.18-.66.17-1,.05-.67-.19-1.32-.67-1.79-.44-.39-1.01-.6-1.6-.59-.67-.03-1.31.23-1.78.71-.46.51-.7,1.18-.67,1.87h-1.48c0-.55.09-1.1.29-1.61.18-.46.44-.89.79-1.24.35-.35.77-.62,1.23-.8.51-.19,1.05-.28,1.6-.27.52,0,1.04.08,1.53.25.45.15.86.4,1.2.73.34.32.6.72.77,1.16.2.49.29,1.01.28,1.53.01.48-.07.96-.25,1.41-.17.4-.41.77-.71,1.08-.33.34-.69.65-1.09.92l-1.36.88-1.15.77c-.31.23-.61.48-.88.76-.23.25-.43.52-.6.82-.16.31-.27.65-.32,1h6.56Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m707.3,331.31c-1.09.06-2.17-.29-3-1-.78-.74-1.22-1.76-1.22-2.83h1.45c.02.71.32,1.38.83,1.88.52.49,1.22.75,1.94.72.69.04,1.37-.16,1.93-.57.48-.38.75-.96.72-1.57.02-.45-.13-.88-.41-1.23-.41-.39-.9-.69-1.43-.87l-1.8-.68c-.8-.27-1.52-.74-2.08-1.37-.45-.6-.68-1.33-.65-2.08,0-.45.09-.89.28-1.29.18-.39.44-.73.77-1,.36-.29.76-.51,1.2-.65.5-.16,1.02-.24,1.55-.23,1-.06,1.98.27,2.74.91.7.65,1.11,1.55,1.13,2.5h-1.46c-.02-.59-.27-1.15-.69-1.56-.48-.4-1.09-.61-1.72-.57-.61-.03-1.21.14-1.7.5-.42.32-.66.83-.64,1.36-.02.48.13.95.43,1.32.4.42.9.74,1.45.93l1.82.7c.77.25,1.46.7,2,1.3.44.57.66,1.28.62,2,0,.5-.09.99-.29,1.44-.18.42-.46.8-.82,1.09-.38.31-.82.55-1.29.69-.55.14-1.11.19-1.67.16h0Zm6.7-12.6h7.15v1.3h-5.7v4h5.53v1.3h-5.53v4.5h5.92v1.3h-7.36v-12.4Zm15.58,12.6c-.88,0-1.75-.16-2.56-.48-1.53-.63-2.74-1.85-3.37-3.38-.65-1.63-.65-3.46,0-5.09.63-1.53,1.85-2.74,3.38-3.37,1.51-.6,3.18-.65,4.72-.15.65.2,1.26.52,1.8.94.52.4.97.9,1.32,1.46.36.59.61,1.23.74,1.91h-1.55c-.13-.49-.34-.95-.61-1.37-.55-.82-1.36-1.42-2.3-1.7-.5-.15-1.02-.23-1.55-.23-.69-.01-1.37.12-2,.39-.59.24-1.12.61-1.56,1.07-.45.46-.81,1-1.05,1.6-.25.64-.38,1.32-.37,2,0,.68.12,1.36.37,2,.24.6.6,1.14,1.05,1.6.44.46.97.82,1.56,1.07.63.27,1.31.4,2,.39,1.02.02,2.03-.29,2.85-.9.8-.59,1.37-1.45,1.61-2.42h1.55c-.13.68-.38,1.33-.74,1.92-.35.57-.79,1.06-1.32,1.47-.54.42-1.15.74-1.8.94-.7.22-1.43.33-2.17.33h0Zm10.95-11.3h-3.67v-1.3h8.84v1.3h-3.78v11.1h-1.43l.04-11.1Zm12.67,11.3c-.86,0-1.71-.16-2.5-.48-.75-.32-1.43-.78-2-1.36-.58-.57-1.04-1.25-1.36-2-.32-.8-.49-1.66-.48-2.53,0-.87.16-1.73.48-2.54.63-1.53,1.85-2.75,3.39-3.37,1.63-.65,3.44-.65,5.07,0,1.53.63,2.75,1.84,3.38,3.37.33.81.49,1.67.49,2.54,0,.87-.16,1.73-.49,2.53-.32.75-.78,1.42-1.35,2-.57.58-1.25,1.04-2,1.36-.84.34-1.74.5-2.64.48h0Zm0-1.34c.67,0,1.33-.13,1.95-.39.59-.25,1.13-.61,1.57-1.07.44-.46.78-1.01,1-1.61.25-.64.38-1.32.37-2,0-.69-.12-1.36-.38-2-.23-.59-.57-1.14-1-1.6-.44-.46-.97-.82-1.56-1.06-1.25-.51-2.65-.51-3.9,0-.59.24-1.12.6-1.56,1.06-.43.46-.77,1.01-1,1.6-.26.63-.39,1.31-.38,2,0,.68.12,1.36.37,2,.22.6.56,1.15,1,1.61.44.46.98.82,1.57,1.07.62.26,1.28.4,1.95.39h0Zm9.1-11.26h3.86c1.05-.05,2.07.31,2.86,1,.7.7,1.06,1.66,1,2.65.03.84-.22,1.66-.72,2.33-.5.63-1.21,1.07-2,1.24l3.52,5.22h-1.72l-3.4-5.13h-2v5.1h-1.44l.04-12.41Zm3.76,6c.67.04,1.32-.18,1.83-.62.87-.99.87-2.47,0-3.46-.52-.43-1.18-.65-1.85-.61h-2.34v4.7h2.36Zm17.58-.14c.59.23,1.1.63,1.45,1.15.34.55.52,1.18.5,1.83,0,.52-.1,1.03-.31,1.51-.2.45-.5.85-.87,1.18-.38.35-.83.62-1.31.79-.54.19-1.1.29-1.67.28-.55,0-1.1-.08-1.62-.26-.47-.17-.91-.43-1.27-.78-.35-.35-.63-.77-.82-1.23-.21-.52-.32-1.07-.33-1.63h1.46c-.01.69.25,1.36.72,1.86.49.47,1.14.72,1.82.7.38,0,.75-.06,1.11-.18.31-.1.6-.27.85-.49.24-.2.43-.46.56-.75.13-.32.19-.66.19-1,.03-.64-.23-1.27-.72-1.69-.57-.44-1.28-.65-2-.61h-1.23v-1.3h1.2c.62.04,1.23-.15,1.71-.54.41-.4.63-.96.6-1.54.03-.56-.19-1.11-.59-1.51-.47-.38-1.06-.58-1.66-.54-.62-.03-1.23.18-1.72.57-.44.38-.7.93-.7,1.51h-1.43c0-.48.12-.94.33-1.37.2-.42.48-.79.83-1.09.36-.31.77-.55,1.21-.71.49-.18,1.01-.26,1.53-.26.52,0,1.03.07,1.52.24.43.15.82.38,1.16.68.32.27.57.62.74,1,.18.43.28.89.27,1.35.02.57-.12,1.13-.4,1.63-.26.49-.64.9-1.12,1.19h.01Z"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(465.01 169.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 0,
    y: 0
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 6.69,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 16.53,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 23.59,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 32,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 37.71,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 41.09,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 46.89,
    y: 0
  }, "ANE"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(816.27 315.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HARMON")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 3.87,
    y: 15.36
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 11.32,
    y: 15.36
  }, "VENUE"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m823.85,198.28h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m828.06,201.67c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m838.71,197.37h2.67c1.68,0,2.71.97,2.71,2.51s-1.05,2.57-2.71,2.57h-1.68v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m825.55,217.11v2.3c-.81,1.38-2.21,2.07-3.84,2.07-2.7,0-4.62-1.89-4.62-4.48s1.91-4.42,4.49-4.42c1.91,0,3.38,1.02,3.88,2.7h-1.1c-.47-1.13-1.5-1.77-2.8-1.77-1.98,0-3.43,1.46-3.43,3.48s1.47,3.55,3.6,3.55c1.13,0,2.15-.41,2.83-1.36v-1.18h-2.89v-.91h3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m827.02,217.03c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m837.67,212.73h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m843.64,212.73h4.9v.91h-3.9v2.98h3.79v.91h-3.79v3.81h-1v-8.62Z"
  }))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(643.59 10.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 0
  }, "HARBOR IS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 63.36,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 69.16,
    y: 0
  }, "AND "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 9.32,
    y: 15.36
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 17.73,
    y: 15.36
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 23.69,
    y: 15.36
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 32.1,
    y: 15.36
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 39.24,
    y: 15.36
  }, "TMEN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 72.35,
    y: 15.36
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 79.2,
    y: 15.36
  }, "S"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m598.01,124.59h2.68c1.68,0,2.71.97,2.71,2.51,0,1.29-.72,2.2-1.91,2.48l2.45,3.62h-1.19l-2.34-3.53h-1.4v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m604.79,128.89c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m614.87,128.89c0-2.52,1.92-4.44,4.46-4.44,2.15,0,3.81,1.28,4.19,3.23h-1.08c-.36-1.4-1.57-2.29-3.1-2.29-1.93,0-3.43,1.52-3.43,3.51s1.48,3.52,3.43,3.52c1.52,0,2.73-.9,3.1-2.3h1.08c-.37,1.96-2.04,3.24-4.19,3.24-2.55,0-4.46-1.91-4.46-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m625.27,124.59h1v3.55h4.39v-3.55h1v8.62h-1v-4.16h-4.39v4.16h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m633.94,124.59h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m640.74,124.59h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m646.71,124.59h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m652.67,124.59h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m667.72,131.01h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m676.66,124.59l-3.1,8.62h-1.08l-3.08-8.62h1.09l2.55,7.32,2.55-7.32h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m678.19,124.59h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m691.39,124.59v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m693.57,129.86v-5.27h1v5.31c0,1.55.86,2.54,2.21,2.54s2.21-.96,2.21-2.54v-5.31h1v5.27c0,2.14-1.23,3.48-3.21,3.48s-3.21-1.34-3.21-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m702.19,124.59h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m610.8,139.95h1v8.62h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m620.49,139.95v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m624.56,140.86h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m629.73,139.95h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m636.53,139.95h2.68c1.68,0,2.71.97,2.71,2.51,0,1.29-.72,2.2-1.91,2.48l2.45,3.62h-1.19l-2.34-3.53h-1.4v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m643.33,146.02h1.01c.06,1.08.83,1.8,1.92,1.8s1.84-.58,1.84-1.48c0-.7-.35-1.09-1.28-1.46l-1.24-.47c-1.33-.51-1.89-1.24-1.89-2.39,0-1.31,1.08-2.2,2.64-2.2s2.59.9,2.69,2.37h-1.01c-.06-.92-.67-1.49-1.68-1.49s-1.63.51-1.63,1.29.37,1.19,1.31,1.56l1.27.49c1.31.5,1.84,1.17,1.84,2.27,0,1.47-1.11,2.41-2.84,2.41s-2.87-1.04-2.95-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m650.8,139.95h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m657.03,144.25c0-2.52,1.92-4.44,4.46-4.44,2.15,0,3.82,1.28,4.19,3.23h-1.08c-.36-1.4-1.57-2.29-3.1-2.29-1.93,0-3.43,1.52-3.43,3.51s1.49,3.52,3.43,3.52c1.52,0,2.73-.9,3.1-2.3h1.08c-.37,1.96-2.04,3.24-4.19,3.24-2.55,0-4.46-1.91-4.46-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m668.96,140.86h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m674.14,139.95h1v8.62h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m676.86,144.25c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m693.91,139.95v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m365.31,109.08l-2.52,8.62h-1.14l-1.91-7.1-1.9,7.1h-1.15l-2.52-8.62h1.09l2.02,7.26,1.88-7.26h1.15l1.88,7.28,2.04-7.28h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m367.13,109.08h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m373.27,115.15h1.01c.06,1.08.83,1.81,1.92,1.81s1.84-.58,1.84-1.48c0-.7-.35-1.09-1.28-1.46l-1.24-.47c-1.33-.51-1.89-1.24-1.89-2.39,0-1.31,1.08-2.2,2.64-2.2s2.59.9,2.69,2.37h-1.01c-.06-.92-.67-1.49-1.68-1.49s-1.63.51-1.63,1.29.37,1.19,1.31,1.56l1.27.49c1.31.5,1.84,1.16,1.84,2.27,0,1.47-1.11,2.41-2.84,2.41s-2.87-1.04-2.94-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m382.29,109.99h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m386.5,113.38c0-2.52,1.92-4.44,4.46-4.44,2.15,0,3.81,1.28,4.19,3.23h-1.08c-.36-1.4-1.57-2.29-3.1-2.29-1.93,0-3.43,1.52-3.43,3.51s1.48,3.52,3.43,3.52c1.52,0,2.73-.9,3.1-2.3h1.08c-.37,1.96-2.04,3.24-4.19,3.24-2.55,0-4.46-1.91-4.46-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m396.89,109.08h1v3.55h4.39v-3.55h1v8.62h-1v-4.16h-4.39v4.16h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m405.57,109.08h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m411.7,115.15h1.01c.06,1.08.83,1.81,1.92,1.81s1.84-.58,1.84-1.48c0-.7-.35-1.09-1.28-1.46l-1.24-.47c-1.33-.51-1.89-1.24-1.89-2.39,0-1.31,1.08-2.2,2.64-2.2s2.59.9,2.69,2.37h-1.01c-.06-.92-.67-1.49-1.68-1.49s-1.63.51-1.63,1.29.37,1.19,1.31,1.56l1.27.49c1.31.5,1.84,1.16,1.84,2.27,0,1.47-1.11,2.41-2.84,2.41s-2.87-1.04-2.94-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m420.73,109.99h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m425.9,109.08h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m432.7,109.08h2.68c1.68,0,2.71.97,2.71,2.51,0,1.29-.72,2.2-1.91,2.48l2.45,3.62h-1.19l-2.34-3.53h-1.4v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m380.08,124.44h2.62c2.84,0,4.71,1.7,4.71,4.29s-1.89,4.33-4.71,4.33h-2.62v-8.62Zm2.62,7.71c2.2,0,3.67-1.37,3.67-3.42s-1.46-3.38-3.67-3.38h-1.63v6.8h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m389.16,124.44h2.68c1.68,0,2.71.97,2.71,2.51,0,1.29-.72,2.2-1.91,2.48l2.45,3.62h-1.19l-2.34-3.53h-1.4v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m396.62,124.44h1v8.62h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m406.4,124.44l-3.1,8.62h-1.08l-3.08-8.62h1.09l2.55,7.32,2.55-7.32h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m407.93,124.44h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(300.19 205.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 9.45,
    y: 0
  }, "AE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 24.65,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 31.35,
    y: 0
  }, "ARS "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.43,
    y: 15.36
  }, "FORUM")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m47.16,304.42l-2.52,8.62h-1.14l-1.91-7.11-1.9,7.11h-1.15l-2.52-8.62h1.09l2.02,7.26,1.88-7.26h1.15l1.88,7.28,2.04-7.28h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m52.15,309.34v3.7h-1v-3.73l-2.88-4.89h1.15l2.24,3.96,2.23-3.96h1.14l-2.88,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m63.02,304.42v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m71.71,304.42v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m36.51,319.78h1v3.55h4.39v-3.55h1v8.62h-1v-4.16h-4.39v4.16h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m44.62,324.08c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m56.81,320.69h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m61.98,319.78h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m68.78,319.78h1v7.71h3.57v.91h-4.57v-8.62Z"
  }))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(201.67 479.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 0
  }, "THE MI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 39.77,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 46.99,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 55.01,
    y: 0
  }, "GE"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m422.2,500.9c0-2.52,1.92-4.44,4.46-4.44,2.15,0,3.81,1.28,4.19,3.23h-1.08c-.36-1.4-1.57-2.29-3.1-2.29-1.93,0-3.43,1.52-3.43,3.51s1.48,3.52,3.43,3.52c1.52,0,2.73-.9,3.1-2.3h1.08c-.37,1.96-2.04,3.24-4.19,3.24-2.55,0-4.46-1.91-4.46-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m437.22,503.02h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m440.62,496.6h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m446.75,502.66h1.01c.06,1.08.83,1.81,1.92,1.81s1.84-.58,1.84-1.49c0-.7-.35-1.09-1.28-1.46l-1.24-.47c-1.33-.51-1.89-1.24-1.89-2.39,0-1.31,1.08-2.2,2.64-2.2s2.59.9,2.69,2.37h-1.01c-.06-.92-.67-1.49-1.68-1.49s-1.63.51-1.63,1.29.37,1.19,1.31,1.56l1.27.49c1.31.5,1.84,1.16,1.84,2.27,0,1.47-1.11,2.41-2.84,2.41s-2.87-1.04-2.94-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m459.12,503.02h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m462.52,496.6h2.67c1.68,0,2.71.97,2.71,2.51,0,1.29-.72,2.2-1.91,2.48l2.45,3.62h-1.19l-2.34-3.53h-1.4v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m469.32,502.66h1.01c.06,1.08.83,1.81,1.92,1.81s1.84-.58,1.84-1.49c0-.7-.35-1.09-1.28-1.46l-1.24-.47c-1.33-.51-1.89-1.24-1.89-2.39,0-1.31,1.08-2.2,2.64-2.2s2.59.9,2.69,2.37h-1.01c-.06-.92-.67-1.49-1.68-1.49s-1.63.51-1.63,1.29.37,1.19,1.31,1.56l1.27.49c1.31.5,1.84,1.16,1.84,2.27,0,1.47-1.11,2.41-2.84,2.41s-2.87-1.04-2.95-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m427.37,511.96h2.68c1.68,0,2.71.97,2.71,2.51s-1.05,2.57-2.71,2.57h-1.68v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m438.33,518.38h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m441.73,511.96h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m452.54,518.38h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m454.99,516.26c0-2.52,1.92-4.44,4.46-4.44,2.15,0,3.81,1.28,4.19,3.23h-1.08c-.36-1.39-1.57-2.29-3.1-2.29-1.93,0-3.43,1.52-3.43,3.51s1.48,3.52,3.43,3.52c1.52,0,2.73-.9,3.1-2.3h1.08c-.37,1.96-2.04,3.24-4.19,3.24-2.55,0-4.46-1.91-4.46-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m465.39,511.96h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m580.82,502.23c0,1.48-1.09,2.41-2.84,2.41h-3.23v-8.62h3.1c1.59,0,2.56.79,2.56,2.12,0,.86-.33,1.5-.95,1.87.87.37,1.36,1.14,1.36,2.21Zm-5.07-5.31v2.73h2.02c1.04,0,1.61-.51,1.61-1.38s-.52-1.34-1.56-1.34h-2.07Zm2.15,6.82c1.2,0,1.88-.59,1.88-1.63s-.74-1.58-1.96-1.58h-2.07v3.2h2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m582.53,496.02h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m589.33,496.02h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m595.3,496.02h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m606.1,502.45h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m617.02,500.4v2.3c-.81,1.38-2.21,2.07-3.84,2.07-2.7,0-4.62-1.89-4.62-4.48s1.91-4.42,4.49-4.42c1.91,0,3.38,1.02,3.88,2.7h-1.1c-.47-1.13-1.5-1.77-2.8-1.77-1.98,0-3.43,1.46-3.43,3.48s1.47,3.55,3.6,3.55c1.13,0,2.15-.41,2.83-1.36v-1.18h-2.89v-.91h3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m619.05,496.02h1v8.62h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m621.78,500.32c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m570.19,511.38h4.9v.91h-3.91v2.98h3.79v.91h-3.79v3.82h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m576.07,515.68c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m586.6,516.66v-5.27h1v5.31c0,1.55.86,2.53,2.21,2.53s2.21-.96,2.21-2.53v-5.31h1v5.27c0,2.14-1.23,3.48-3.21,3.48s-3.21-1.34-3.21-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m601.63,511.38v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m605.7,512.29h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m614.79,517.81h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m618.19,511.38h1v8.62h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m627.88,511.38v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m629.51,517.45h1.01c.06,1.08.83,1.8,1.92,1.8s1.84-.58,1.84-1.48c0-.7-.35-1.09-1.28-1.46l-1.24-.47c-1.33-.51-1.89-1.24-1.89-2.39,0-1.31,1.08-2.2,2.64-2.2s2.59.9,2.69,2.37h-1.01c-.06-.92-.67-1.49-1.68-1.49s-1.63.51-1.63,1.29.37,1.19,1.31,1.56l1.27.49c1.31.5,1.84,1.17,1.84,2.27,0,1.47-1.11,2.41-2.84,2.41s-2.87-1.04-2.94-2.69Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m723.35,417.51h2.68c1.68,0,2.71.97,2.71,2.51s-1.05,2.57-2.71,2.57h-1.68v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m730.3,417.51h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m741.11,423.93h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m750.91,417.51v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m753.2,417.51h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m761.78,418.41h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m705.65,432.86h1v3.55h4.39v-3.55h1v8.62h-1v-4.16h-4.39v4.16h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m713.76,437.17c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m724.41,432.86h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m730.38,432.86h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m738.2,437.78v3.7h-1v-3.73l-2.88-4.89h1.15l2.24,3.96,2.23-3.96h1.14l-2.88,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m753.32,432.86l-2.52,8.62h-1.14l-1.91-7.11-1.9,7.11h-1.15l-2.52-8.62h1.09l2.02,7.26,1.88-7.26h1.15l1.88,7.28,2.04-7.28h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m754.33,437.17c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m764.41,437.17c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m775.06,432.86h2.62c2.84,0,4.71,1.7,4.71,4.29s-1.89,4.33-4.71,4.33h-2.62v-8.62Zm2.62,7.71c2.2,0,3.67-1.37,3.67-3.42s-1.46-3.38-3.67-3.38h-1.63v6.8h1.63Z"
  }))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(689.83 504.64)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 0
  }, "COSMOPOLI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 73.78,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 79.64,
    y: 0
  }, "AN"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m141.56,69.93h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m148.35,69.93h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m159.16,76.36h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m168.09,69.93l-3.1,8.62h-1.08l-3.08-8.62h1.09l2.55,7.32,2.55-7.32h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m173.67,76.36h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m177.77,70.84h-2.55v-.91h6.17v.91h-2.62v7.71h-1v-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m182.94,69.93h4.97v.91h-3.97v2.75h3.84v.91h-3.84v3.14h4.11v.91h-5.11v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m189.74,69.93h2.62c2.84,0,4.71,1.7,4.71,4.29s-1.89,4.33-4.71,4.33h-2.62v-8.62Zm2.62,7.71c2.2,0,3.67-1.37,3.67-3.42s-1.46-3.38-3.67-3.38h-1.63v6.8h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m146.49,85.29v8.62h-1v-7.05l-2.73,7.05h-.93l-2.73-7.05v7.05h-.99v-8.62s1.41,0,1.41,0l2.78,7.26,2.75-7.26h1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m148.21,89.59c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m165.26,85.29v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m166.99,89.59c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m177.64,85.29h2.68c1.68,0,2.71.97,2.71,2.51,0,1.29-.72,2.2-1.91,2.48l2.45,3.62h-1.19l-2.34-3.53h-1.4v3.53h-1v-8.62Zm2.61,4.16c1.08,0,1.73-.6,1.73-1.64s-.63-1.61-1.73-1.61h-1.63v3.25h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m189.86,91.72h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m193.27,85.29h1v8.62h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m196.56,85.29h1v7.71h3.57v.91h-4.57v-8.62Z"
  }))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(264.88 119.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MSG"), /*#__PURE__*/React.createElement("tspan", {
    x: -8.04,
    y: 15.36
  }, "SPHERE"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(107.48 215.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 6.69,
    y: 0
  }, "ANDS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 39.68,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 42.93,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 50.38,
    y: 0
  }, "VENUE"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(210.58 411.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 0,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 5.8,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 14.08,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 20.89,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 24.14,
    y: 0
  }, "VE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 38.96,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 48.51,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 56.79,
    y: 0
  }, "S BOULE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 106.12,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 113.19,
    y: 0
  }, "ARD"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(89.41 413.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 0
  }, "TRE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 21.21,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 29.49,
    y: 0
  }, "SURE "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 15.36
  }, "IS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 10.1,
    y: 15.36
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 15.9,
    y: 15.36
  }, "AND"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(416.9 460.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 6.44,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 12.24,
    y: 0
  }, "AMINGO"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(581.92 458.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 5.95,
    y: 0
  }, "ARIS"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m23.31,357.51h4.9v.91h-3.9v2.98h3.79v.91h-3.79v3.82h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m34.3,363.94h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m36.91,363.58h1.01c.06,1.08.83,1.8,1.92,1.8s1.84-.58,1.84-1.48c0-.7-.35-1.09-1.28-1.46l-1.24-.47c-1.33-.51-1.89-1.24-1.89-2.39,0-1.31,1.08-2.2,2.64-2.2s2.59.9,2.69,2.37h-1.01c-.06-.92-.67-1.49-1.68-1.49s-1.63.51-1.63,1.29.37,1.19,1.31,1.56l1.27.49c1.31.5,1.84,1.17,1.84,2.27,0,1.47-1.11,2.41-2.84,2.41s-2.87-1.04-2.94-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m44.39,357.51h1v3.55h4.39v-3.55h1v8.62h-1v-4.16h-4.39v4.16h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m53.07,357.51h1v8.62h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m55.79,361.81c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m72.84,357.51v8.62h-1.09l-4.31-7v7h-1v-8.62h1.15l4.24,6.86v-6.86h1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.65,378.94h1.01c.06,1.08.83,1.81,1.92,1.81s1.84-.58,1.84-1.49c0-.7-.35-1.09-1.28-1.46l-1.24-.47c-1.33-.51-1.89-1.24-1.89-2.39,0-1.31,1.08-2.2,2.64-2.2s2.59.9,2.69,2.37h-1.01c-.06-.92-.67-1.49-1.68-1.49s-1.63.51-1.63,1.29.37,1.19,1.31,1.56l1.27.49c1.31.5,1.84,1.16,1.84,2.27,0,1.47-1.11,2.41-2.84,2.41s-2.87-1.04-2.94-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m20.13,372.87h1v3.55h4.39v-3.55h1v8.62h-1v-4.16h-4.39v4.16h-1v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m28.24,377.17c0-2.52,1.92-4.44,4.46-4.44s4.44,1.92,4.44,4.44-1.92,4.46-4.44,4.46-4.46-1.93-4.46-4.46Zm7.87-.01c0-2-1.47-3.5-3.42-3.5s-3.42,1.5-3.42,3.5,1.46,3.53,3.42,3.53,3.42-1.51,3.42-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m49.29,372.87l-2.52,8.62h-1.14l-1.91-7.1-1.9,7.1h-1.15l-2.52-8.62h1.09l2.02,7.26,1.88-7.26h1.15l1.88,7.28,2.04-7.28h1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m62.75,372.87v8.62h-1v-7.05l-2.73,7.05h-.93l-2.73-7.05v7.05h-.99v-8.62s1.41,0,1.41,0l2.78,7.26,2.75-7.26h1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m70.05,379.3h-3.89l-.82,2.19h-1.06l3.29-8.62h1.08l3.28,8.62h-1.05l-.82-2.19Zm-3.56-.88h3.24l-1.63-4.43-1.61,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m73.45,372.87h1v7.71h3.57v.91h-4.57v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m79.42,372.87h1v7.71h3.57v.91h-4.57v-8.62Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m366.98,483.4c-6.06,0-44.37-.62-81.83-15.61-39.38-15.75-109.97-55.08-112.96-56.75l-.51-.33c-.52-.38-52.22-38.12-67.85-44.59l-.27-.12c-2.66-1.29-6.4-2.01-8.88-2.49-1.04-.2-1.86-.36-2.56-.54-.14-.02-.29-.03-.44-.04-1.48-.12-4.56-.38-6.65-3.23-2.35-3.21-1.75-7.58-.97-11.02,2.12-9.32,10.97-41.36,11.35-42.72l.12-.38c.28-.78,7.18-19.23,25.93-27.05,6.54-2.73,11.82-4.97,16.16-6.81,6.97-2.96,11.58-4.92,15.25-6.26,6.45-2.36,26.26-11.13,40.41-23.28.24-.23.55-.51.92-.85,3.49-3.14,12.73-11.48,14.98-30.6.42-9.07,1.26-50.67,1.26-60.3s.39-71.71.42-76.29c-.11-1.37-.08-4.84,2.53-7.32,1.12-1.06,3.62-2.72,7.8-1.91,4.99.97,32.7,6.01,32.98,6.06l.42.09c1.82.48,4.22.64,5.27.37.17-.77.27-1.5.36-2.21.71-5.45,2.81-8.89,11.08-9.2h.16c33.68-1.28,58.45,12.63,69.72,39.18l.14.37c.1.31.23.62.38.97,1.34,3.3,3.58,8.82,3.83,28.92.28,21.94.28,43.19.28,43.4l-.02.4c-.16,2.19.11,7.39,2,9.4.36.38.85.73,1.98.72,10.17-.14,217.83-4.05,219.93-4.09l80.8-1.46h.09c17.91.29,45.72-.9,51.47-4.51l.48-.3.84-.29c22.61-7.84,27.49-19.76,28.34-26.35-.02-9.71-1.12-15.76-7.07-23.59-6.6-8.67-13.8-19.36-14.1-19.81-.48-.73-4.39-7.02-4.8-18.99-.37-10.81-.75-23.99-.75-24.12v-.22s0-.22,0-.22c.07-1.23.68-7.49,5.6-9.74,2.18-.99,5.74-1.43,10.35,2.11l.45.34.36.44c6.24,7.56,27.34,36.66,28.24,37.89l39.4,52.53c1.63,1.94,17.46,21.49,17.46,44.9,0,22.12-2.19,250.21-2.26,257.22.08,1.9.07,9.37-4.94,13.27-.82.64-1.71,1.22-2.58,1.78-3.8,2.47-5.47,3.88-5.47,7.07,0,.73,0,1.41.02,2.04.05,3.95.09,7.36-2.55,10.04-2.38,2.41-5.72,2.9-10,2.9-8.36,0-279.22,1.12-281.96,1.13h-129.34c-.1,0-.37,0-.78,0Zm-189.65-80.94c4.85,2.7,73.94,41.01,111.53,56.05,38.08,15.23,78.42,14.88,78.83,14.89h129.36c2.73-.01,273.61-1.13,282-1.13,1.22,0,2.03-.06,2.54-.12.03-.75.02-1.79,0-2.69,0-.67-.02-1.39-.02-2.16,0-8.95,6.27-13.02,10.02-15.46.72-.47,1.41-.91,1.89-1.29.62-.48,1.18-3.06,1.09-5.02v-.31c.02-2.35,2.25-234.96,2.25-257.27,0-20.41-15.03-38.37-15.19-38.55l-.19-.24-39.53-52.71c-.25-.35-19.85-27.37-26.94-36.27.08,2.64.41,13.99.74,23.5.3,8.78,2.92,13.43,3.16,13.83.66.98,7.57,11.2,13.71,19.26,7.62,10.02,9.11,18.57,9.11,29.95l-.03.58c-1.77,15.25-14.15,27.63-34.87,34.86-11.06,6.12-48.54,5.84-56.31,5.71l-80.62,1.46c-2.09.04-209.77,3.96-219.97,4.09-3.76.04-7-1.3-9.43-3.9-5.14-5.5-4.8-14.94-4.67-16.81,0-2.11-.02-22.29-.28-43.1-.23-18.22-2.1-22.82-3.1-25.29-.2-.49-.37-.92-.52-1.35-5.58-13.02-20.75-34.43-60.07-32.94h-.16c-.65.03-1.14.07-1.49.12-.02.13-.03.26-.05.38-.14,1.06-.31,2.39-.73,3.97-.62,2.36-2.08,4.26-4.21,5.49-4.63,2.67-11.22,1.26-13,.8-2.45-.45-24.05-4.38-31.33-5.75-.05,8.65-.42,66.21-.42,75.4,0,10.04-.84,51.87-1.28,60.95l-.03.33c-2.65,22.99-14.38,33.57-18.24,37.05-.29.27-.53.48-.7.64l-.27.25c-18.43,15.87-43.37,25.1-43.62,25.19-3.43,1.25-7.94,3.17-14.77,6.07-4.36,1.85-9.66,4.1-16.22,6.84-13.82,5.76-19.68,19.5-20.32,21.1-.83,3.01-9.2,33.34-11.17,42.03-.21.93-.33,1.64-.38,2.16.37.05.76.12,1.17.23.38.1,1.15.25,1.97.41,2.95.57,7.4,1.43,11.2,3.24,16.45,6.89,65.14,42.3,69.55,45.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m798.7,206.08l-2-.07c0-.26.72-26.14-12.12-32.96l-.17-.11c-6.7-5.55-8.36-8.69-6.58-12.44,1.64-3.46,1.42-4.21-3.42-11.41-3.77-5.63-27.86-36.83-38.04-49.98-2.2-2.84-4.07-5.54-5.7-8.24-1.99-3.28-4.01-5.17-5.56-5.18h-.01c-.93,0-1.83.7-2.69,2.08-4.2,6.75-1.1,12.74.95,16.7.28.53.53,1.03.74,1.47,1.72,3.63,11.48,15.95,11.58,16.07l-1.57,1.24c-.41-.51-10-12.62-11.82-16.46-.2-.43-.45-.9-.71-1.41-2.12-4.1-5.67-10.96-.87-18.68,1.25-2.01,2.75-3.08,4.41-3.02,2.36.01,4.8,2.08,7.26,6.14,1.6,2.64,3.42,5.27,5.57,8.05,10.19,13.17,34.31,44.42,38.12,50.09,4.79,7.14,5.73,8.81,3.56,13.38-1.13,2.39-.52,4.59,5.97,9.98,5.85,3.15,9.83,9.97,11.83,20.28,1.47,7.59,1.27,14.19,1.26,14.46Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLasVegas);
export default __webpack_public_path__ + "static/media/las-vegas.49df451617786053c454d8a294579389.svg";
export { ForwardRef as ReactComponent };